import { SnackbarType } from "src/app/models/snackbar/snackbar.model";

export class SnackBarUtils {
  static setSnackBar(message: string, snackbarType: SnackbarType) {
    return {
      snackbar: {
        message: message,
        type: snackbarType,
      },
    };
  }
}
